
  import { computed, defineComponent, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useStore } from 'vuex';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { useRoute } from 'vue-router';
  import Multiselect from '@vueform/multiselect';
  import { PackagesFilterListInfo } from '@/store/modules/PackagesModule';
  export default defineComponent({
    name: 'Shipments-filter',
    emit: ['type-selected', 'reset'],
    components: { Multiselect },
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const route = useRoute();
      const pathRoute = ref<string>(route.path);
      const selectedGovernorate = ref<string>('');
      const selectedArea = ref<Array<string>>([]);
      const selectedHubs = ref<Array<string>>([]);
      const selectedItems = ref<PackagesFilterListInfo>({
        phone: '',
        name: '',
        driverName: '',
        trackNumber: '',
        docId: '',
        statusId: '',
        originType: '',
        areaName: '',
        areaId: [],
        governorateId: '',
        startDate: '',
        endDate: '',
        shipmentTrackNumber: '',
        officeName: '',
        hubId: [],
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('type-selected', selectedItems.value);
      };

      if (route.name) {
        selectedArea.value = [];
        selectedGovernorate.value = '';
        selectedHubs.value = [];
        selectedItems.value = {
          phone: '',
          name: '',
          driverName: '',
          trackNumber: '',
          docId: '',
          statusId: '',
          originType: '',
          areaName: '',
          areaId: [],
          governorateId: '',
          startDate: '',
          endDate: '',
          shipmentTrackNumber: '',
          officeName: '',
          hubId: [],
        };
        emit('reset', selectedItems.value);
      }

      const onReset = () => {
        selectedArea.value = [];
        selectedGovernorate.value = '';
        selectedHubs.value = [];
        selectedItems.value = {
          phone: '',
          name: '',
          driverName: '',
          trackNumber: '',
          docId: '',
          statusId: '',
          originType: '',
          areaName: '',
          areaId: [],
          governorateId: '',
          startDate: '',
          endDate: '',
          shipmentTrackNumber: '',
          officeName: '',
          hubId: [],
        };
        emit('reset', selectedItems.value);
      };

      watch(
        () => selectedGovernorate.value,
        async () => {
          if (selectedGovernorate.value) {
            selectedArea.value = [];
            await store.dispatch(
              Actions.GET_SHIPMENT_AREAS,
              selectedGovernorate.value
            );
          }
        }
      );

      watch(
        () => selectedGovernorate.value,
        (newGovernorate, oldGovernorate) => {
          selectedItems.value.governorateId = newGovernorate;
        }
      );

      watch(
        () => selectedArea.value,
        (newAreas, oldAreas) => {
          selectedItems.value.areaId = newAreas;
        }
      );

      watch(
        () => selectedHubs.value,
        (newHubs, oldHubs) => {
          selectedItems.value.hubId = newHubs;
        }
      );

      const areas = computed(() => store.getters.getAllAreasList);
      const areasTitle = () => {
        return areas.value.map((i) => {
          return { title: i.titleTranslate, id: i.id };
        });
      };

      const governorate = computed(() => store.getters.allGovernoratesList);
      const governorateTitle = () => {
        return governorate.value.map((i) => {
          return {
            title: i.title.find((r) => r.languageCode === 'en')?.title,
            id: i.id,
          };
        });
      };

      const hubs = await store.dispatch(Actions.GET_ALL_HUBS_CREATING);

      const hubsTitle = () => {
        return hubs.map((r) => {
          return { title: r.titleTranslate, id: r.id };
        });
      };

      await store.dispatch(Actions.GET_ALL_GOVERNORATES);
      await store.dispatch(Actions.GET_HUB_AREAS);
      await store.dispatch(Actions.GET_ALL_SHIPMENT_STATUSES, 'all');

      reinitializeComponents();
      return {
        pathRoute,
        selectedGovernorate,
        selectedArea,
        selectedHubs,
        governorateTitle,
        hubsTitle,
        areasTitle,
        shipmentStatuses: computed(() => store.getters.shipmentStatusesList),
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
